var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"color_rgb":"#000000","trasparente":_vm.grg_var_transparencia}}),_c('router-view'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }